// Contract color is only a visual cue; the server-provided key remains the identity.
export function unmeContractColor(contractKey) {
  switch (String(contractKey ?? '').trim().toUpperCase()) {
    case 'PRIMARY': return 'border-teal-200 bg-teal-50 text-teal-800';
    case 'SECONDARY': return 'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-800';
    default: return 'border-slate-200 bg-slate-50 text-slate-600';
  }
}
